import React from 'react';
import Projects from '../../api/project'


const RelatedProject = () => {

    return (
        <div className="gl-project-single-item">
            <div className="gl-project-single-title">
                <h3>Related Projects</h3>
            </div>
            <div className="gl-project-area-s2">
                <div className="gl-project-wrap">
                    <div className="row">
                        {Projects.slice(0, 3).map((project, pot) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={pot}>
                                <div className="gl-project-item">
                                    <div className="gl-project-img">
                                        <img src={project.pImg} alt=""/>
                                    </div>
                                    <div className="gl-project-text">
                                        <h2>{project.title}</h2>
                                        <span>{project.subTitle}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
};
export default RelatedProject;

